import { ToasterIdEnum } from "@/enums";
import { DEFAULT_TOASTER_PRIORITY } from "@/lib/constants/toast";
import type { ToasterId } from "@/types";

const mounted = new Set<ToasterId>();
let lastMounted: ToasterId | undefined;

export function registerToaster(id?: ToasterId): void {
  if (!id) return;
  mounted.add(id);
  lastMounted = id;
}

export function unregisterToaster(id?: ToasterId): void {
  if (!id) return;
  mounted.delete(id);
  if (lastMounted === id) lastMounted = Array.from(mounted).at(-1);
}

export function pickToasterId(priority?: ToasterId[]): ToasterId {
  const priorityList = priority ?? DEFAULT_TOASTER_PRIORITY;
  if (priorityList) {
    for (const id of priorityList) if (mounted.has(id)) return id;
  }
  return lastMounted ?? ToasterIdEnum.SYSTEM;
}
